export const environment = {
  production: false,
  microsoft: {
      client_id: '9ec22a20-883f-4e8c-8f9b-358e2588dfb1',
      state: '',
      redirect_url: 'https://cubik.test2.infogones.com/api/microsoft/callback'
  },
};